import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

export type CrispIdentity = {
  tokenId: string,
  emailSignature?: string,
};

export type CrispSessionLink = {
  sessionId: string,
  locale?: string,
  plan?: string,
};

const CrispAPI = {
  getIdentity: () => APIClient(CONFIG.API_ENDPOINT).get<CrispIdentity>(`v1/integrations/crisp/identity`),
  linkSession: (link: CrispSessionLink) => APIClient(CONFIG.API_ENDPOINT).post<void>(`v1/integrations/crisp/session`, link),
};

export default CrispAPI;
